var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1273 8.17251L16.9988 9.30346L15.8668 8.17149C12.9806 5.28527 8.30113 5.28527 5.41491 8.17149C2.52869 11.0577 2.52869 15.7372 5.41491 18.6234L16.271 29.4795C16.6738 29.8823 17.3267 29.8823 17.7295 29.4795L28.594 18.6214C31.4738 15.7256 31.4787 11.0593 28.592 8.17251C25.7005 5.28104 21.0188 5.28104 18.1273 8.17251ZM27.1315 17.167L17.0002 27.2919L6.87332 17.165C4.79255 15.0842 4.79255 11.7107 6.87332 9.62989C8.95408 7.54913 12.3277 7.54913 14.4084 9.62989L16.2749 11.4964C16.6845 11.9059 17.3509 11.898 17.7506 11.4787L19.5857 9.63092C21.6717 7.5449 25.0475 7.5449 27.1335 9.63092C29.2148 11.7122 29.2113 15.0758 27.1315 17.167Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.77275c6cbc60db8d0be340db545f0d81.svg";
export { ForwardRef as ReactComponent };